import { render, staticRenderFns } from "./assignments-employees-rams.vue?vue&type=template&id=5797fe6c"
import script from "./assignments-employees-rams.vue?vue&type=script&lang=js"
export * from "./assignments-employees-rams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports